var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBookmarkEye = function SvgBookmarkEye(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.016,
    height: 134.813,
    viewBox: "0 0 150.016 134.813",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1484",
    "data-name": "Group 1484",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    "data-name": "Group 1483",
    transform: "translate(73.229 32.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M19.915,5.716a3.5,3.5,0,1,0-4.952,4.952l8.578,8.579a34.406,34.406,0,0,0-9.066,9.276C11.965,32.359,10.5,36.4,10.5,39.612a18.848,18.848,0,0,0,2.441,8.369,32.07,32.07,0,0,0,6.974,9C26.192,62.767,35.747,67.51,48.858,67.51A45.762,45.762,0,0,0,67.9,63.6l9.9,9.9a3.5,3.5,0,0,0,4.952-4.952ZM62.528,58.164,55.9,51.539a13.787,13.787,0,0,1-7.114,1.953A13.99,13.99,0,0,1,34.84,39.542a13.788,13.788,0,0,1,1.953-7.114l-8.23-8.23a30.676,30.676,0,0,0-8.3,8.09C18.172,35.5,17.4,38.148,17.4,39.542a12.667,12.667,0,0,0,1.6,5.161,28.064,28.064,0,0,0,5.51,7.114c5.021,4.673,12.9,8.648,24.2,8.648a39.7,39.7,0,0,0,13.669-2.3ZM42.093,37.729a7.6,7.6,0,0,0-.209,1.813,7,7,0,0,0,6.974,6.974,7.6,7.6,0,0,0,1.813-.209Z",
    transform: "translate(-10.5 -4.67)",
    fill: "#22282F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M27.9,12.585A40.529,40.529,0,0,0,18.28,13.7a3.476,3.476,0,0,1-1.6-6.765,47.493,47.493,0,0,1,11.3-1.255c13.112,0,22.666,4.673,28.943,10.531a33.085,33.085,0,0,1,6.974,9,18.848,18.848,0,0,1,2.441,8.369c0,4.533-2.929,11.02-8.369,16.39a3.5,3.5,0,0,1-4.952-4.952c4.673-4.6,6.347-9.416,6.347-11.508a12.667,12.667,0,0,0-1.6-5.161,28.065,28.065,0,0,0-5.51-7.114c-5.021-4.673-12.9-8.648-24.2-8.648Z",
    transform: "translate(10.454 1.364)",
    fill: "#22282F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M65.767,80.925a29.85,29.85,0,0,1-3.7-13.53c0-6.138,2.65-12.345,5.858-17.227a26.616,26.616,0,0,1,2.441-3.278l-.488-.488A14.647,14.647,0,0,1,90.6,25.687l5.021,5.022a19.712,19.712,0,0,1,2.162-.767,57.591,57.591,0,0,1,13.739-1.534c-.279-11.089-1.465-17.715-6-22.249C99.383.021,89.549.021,69.812.021H41.845C22.108-.049,12.275-.049,6.137,6.089S0,22.06,0,41.8v75.045c0,10.113,0,15.2,3.278,17.227s7.811-.209,16.878-4.743L43.31,117.75c6.137-3.069,9.206-4.6,12.484-4.6s6.347,1.534,12.484,4.6l23.154,11.578c9.067,4.533,13.6,6.765,16.878,4.743s3.278-7.114,3.278-17.227V106.452c-15.971,0-28.176-5.789-36.545-13.461A45.846,45.846,0,0,1,65.7,80.925Z",
    transform: "translate(0 -0.008)",
    fill: "#22282F"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBookmarkEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Bookmark - Eye.366d0a17b9d1a574527c31d99299d39e.svg";